import { Routes } from '@angular/router';

export const SUBSCRIPTION_ROUTES: Routes = [
  {
    path: 'service-requests/subscriptions/:subscriptionId',
    loadComponent: () =>
      import('./pages/subscription-detail/subscription-detail').then((m) => m.SubscriptionDetail),
    data: {
      layout: {
        activeItem: 'Service Request',
        breadcrumb: 'View Subscription',
        title: 'Subscription Details',
        subtitle: 'Review recurring service allocation, schedule and execution history',
        showToolbar: false,
        backTo: '/service-requests?tab=subscriptions',
      },
    },
  },
  {
    path: 'service-requests/subscriptions',
    redirectTo: 'service-requests?tab=subscriptions',
    pathMatch: 'full',
  },
];
